import {Partner} from './partner.model';
import {GenericEntity} from './generic-entity.model';
import {DictionaryItem} from './dictionary.model';

export class PasswordPolicy extends GenericEntity {
    code: string;
    name: string;
    minimumLength: number;
    expirationPeriod: number;
    changePeriod: number;
    patterns: string[] | DictionaryItem[];
    partners: Partner[];
    blockAttempts: number;
    blockPeriod: number;
    passwordsStored: number;

    constructor(props = {}) {
        super(props);
        Object.assign(this, props);
    }
}
